import { Injectable } from '@angular/core';
import { AppHttpClient } from '../api.interceptor';
import { environment } from '@env/environment';
import { HelpersService } from '@base/shared/services';

@Injectable()
export class RolesRequests {
  private config = environment;

  constructor(
    private http: AppHttpClient,
    private helpers: HelpersService
  ) {
  }

  /**
   * Get a list of roles
   */
  listRoles(accountId) {
    const url = `${this.config.baseUrl}/v2/${this.config.services.accounts}/${accountId}/roles`;
    return this.http.get(url);
  }

  contractRoles(type) {
    const queryOptions = {
      type
    };

    const query = this.helpers.queryOptions(queryOptions);
    const url = `${this.config.baseUrl}/v2/${this.config.services.contracts}/roles${query}`;
    return this.http.get(url);
  }
}
